export const verifyResponseStatus = async (response: Response) => {
  // console.debug('VerifyResponseStatus response: ', response);

  if (response.ok) return Promise.resolve(response);

  const errorText = await response.text();
  console.log("verifyResponseStatus:data", errorText);

  const error = new Error(response.statusText);
  // error.status = response.status;

  return Promise.reject({ error, errorText });
};

export const handleResponse = (response: Response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data) || response.statusText;
      return Promise.reject({ response, error });
    }

    return data;
  });
};

export const requestBase: RequestInit = (() => {

	const requestHeaders: HeadersInit = new Headers();
	requestHeaders.set('Accept','application/json');
	requestHeaders.set('Content-Type','application/json');

  if (typeof window !== "undefined") {
    return {
      method: "POST",
      credentials: "same-origin",
      headers: requestHeaders,
    };
  } else
    return {
      method: "POST",
      credentials: "same-origin",
      headers: requestHeaders
    };
})();

export const getData = async <TData>(response: Response) => {
	let data = (await response.json()) as TData;

	return data;
};

export interface ApiResponse<TResult> {
	result: TResult;
	response: Response;
	error: Error;
	errorText: string;
  }
  
export const fetchYou = async <TResponse>(url:string,request:RequestInit) =>{
	return fetch(`${url}`, request)
	.then(verifyResponseStatus)
	.then(async (response) => {
	  return {
		result: await getData<TResponse>(response),
	  } as ApiResponse<TResponse>;
	})
	.catch((err: ApiResponse<TResponse>) => err);
}